<template>
	<div id="top">
		<div class="logoEmpresa">
			<router-link to="/">
				<img class="h-100 w-100" src="@/assets/logo.png" />
			</router-link>
		</div>
		<div class="mouse-scroll d-none d-lg-block">
			<pm-scroll></pm-scroll>
		</div>		
		<div class="logoMenu">			
			<pm-menu></pm-menu>
		</div>

		<div class="header-wrapper">
			<div class="zoominheader fondoInicio">
				<div class="zoomoutheader">
					<div class="container-fluid h-100 w-100 p-0">
						<slot name="contenido"></slot>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import PmMenu from "@/components/publica/Menu"
	import PmScroll from "@/components/publica/MouseScroll"

	export default {
		props: ["background"],
		components: {
			PmMenu,
			PmScroll,
		},
		mounted() {
			if (this.background != null) {
				document.querySelector(".fondoInicio").style.backgroundImage =
					"url(" + require(`@/assets/img-pub/${this.background}`) + ")"
			}
		},
	}
</script>

<style scoped>
	
	.header-wrapper {
		height: 100vh;
		width: 100%;
		overflow: hidden;
		background-color: var(--color-azul);
		position: relative;
		z-index: 2;
	}

	.zoominheader {
		height: 100%;
		width: 100%;
		background-size: cover;
		background-repeat: repeat;
		background-position: center;
		position: relative;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		-webkit-animation: zoomin 20s ease-in infinite;
		animation: zoomin 20s ease-in infinite;
		transition: all 3s ease-in-out;
		overflow: hidden;
	}

	.zoomoutheader {
		height: 100%;
		width: 100%;
		background: none;
		-webkit-animation: zoomout 20s ease-in infinite;
		animation: zoomout 20s ease-in infinite;
		transition: all 3s ease-in-out;
		overflow: hidden;
	}

	.logoEmpresa {
		position: absolute;
		margin: 0;
		top: 2em;
		left: 2em;
		z-index: 3;
	}

	.logoMenu {
		position: absolute;
		right: 2em;
		top: 2em;
		color: var(--color-blanco);
		position: absolute;
		z-index: 3;
	}

	.mouse-scroll {
		position: absolute;
		left: 50%;
		bottom: 15px;
		z-index: 3;
	}

	/* xs */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (max-width: 575px) {
		.header-wrapper {
			height: 100vh;
			background-size: cover !important;
		}
		.logoEmpresa {
			top: 10px;
			left: 10px;
			width: 100px;
		}
		.logoMenu {
			right: 10px;
			top: 0px;
		}
	}

	/* sm */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (min-width: 576px) and (max-width: 767px) {
		.header-wrapper {
			height: 100vh;
		}
		.logoEmpresa {
			top: 10px;
			left: 10px;
		}
		.logoMenu {
			right: 10px;
			top: 0px;
		}
	}

	/* md */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 768px) and (max-width: 991px) {
		.header-wrapper {
			height: 100vh;
		}
		.logoEmpresa {
			top: 10px;
			left: 10px;
		}
		.logoMenu {
			right: 10px;
			top: 0px;
		}
	}

	/* lg */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 992px) and (max-width: 1199px) {
	}

	/* xl */
	/* Los estilos aqui contenidos solo se aplicaran a partir del tamaño de pantalla indicado */
	@media screen and (min-width: 1200px) {
	}

	/* Zoom in Keyframes */
	@-webkit-keyframes zoomin {
		0% {
			transform: scale(1);
		}
		50% {
			transform: scale(1.07);
		}
		100% {
			transform: scale(1);
		}
	}
	@keyframes zoomin {
		0% {
			transform: scale(1);
		}
		50% {
			transform: scale(1.07);
		}
		100% {
			transform: scale(1);
		}
	} /*End of Zoom in Keyframes */

	/* Zoom out Keyframes */
	@-webkit-keyframes zoomout {
		0% {
			transform: scale(1);
		}
		50% {
			transform: scale(0.93);
		}
		100% {
			transform: scale(1);
		}
	}
	@keyframes zoomout {
		0% {
			transform: scale(1);
		}
		50% {
			transform: scale(0.93);
		}
		100% {
			transform: scale(1);
		}
	} /*End of Zoom out Keyframes */
</style>